export const MAX_MOBILE_WIDTH = 768;

export const TEMPORARY_RAFFLES_DATE = new Date(Date.UTC(2023, 5, 26, 12));

export const EVA_STAKING_DATE = new Date(Date.UTC(2023, 4, 29, 18));
